//'use strict';

/* Controllers */
angular
    .module("BannerFlowApp")
    .controller(
        "FeedsController",
        function ListController($controller, $scope, $state, $rootScope, ngDialog, Feed, History) {
            $scope.urlParams = $state.params;

            $controller("ListController", { $scope: $scope });

            document.title = "Bannerflow - Feeds";

            $scope.listModel.type = $rootScope.OBJECT_TYPE_FEED;
            $scope.listModel.resource = Feed;

            $scope.model = {};

            $scope.openDynamicAds = function () {
                window.open(
                    "https://facebook-dynamic-ads.bannerflow.com/",
                    "target=_blank",
                    "noopener"
                );
            };

            $scope.openAddFeed = function () {
                ngDialog.open({
                    className: "add-feed-dialog",
                    template: "/legacy-app/views/Create/Feeds/add-feed.html",
                    controller: "FeedWizardController",
                    data: {
                        folderId: $scope.urlParams.folderId
                    },
                    appendTo: "body"
                });
            };

            History.SetLastVisitedBrand("Feeds");
        }
    );
